import React from 'react'
import './message.css'

function Message() {
  return (
    <h1 className='msg-text'>Thank you for participating!</h1>
  )
}

export default Message